<template>
    <div>
       <div class="video-items">
							<div class="active-item-title">首届中国啦啦操文化节视频直播</div>
							<div class="video-box">
								<img class="play-img" src="../../assets/images/activity/pic-logo1@2x.png" alt="">
								<img class="on-play" src="../../assets/images/activity/icon-video-play@2x.png" alt="" srcset="">
							</div>
							<div class="video-bottom">
								<span>2019总决赛</span> 
								<span>235432人阅读</span>
							</div>
						</div>
    </div>
</template>

<style scoped>
    /* 视频 */
	.video-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;}
    .acitve-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;display: flex;justify-content: space-between;}
	.active-items-title-read{display: flex;justify-content: space-between;flex-direction: column;width: 58%;}
.active-item-title{
		 
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1); 
	}
	.active-item-pics{width: 40%;}
	.active-item-pics img{width: 100%;height: 1.4rem;}
	.acitve-item-title{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
	}
	.active-itme-read{ 
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
	}
    .video-bottom{
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
		margin-top: 5px;
	}
	.video-box{
		position: relative;;
	}
	.video-box .play-img{margin-top: 10px;width: 100%;}
	.video-box .on-play{
		width: 1rem;
		height: 1rem;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
	}
</style>

<script>
    export default {
        name: "NewsItem3",
        components: {
        },
        props: {
           

        },

        data: function () {
            return {}
        },

        methods: {
            
        },

        filters: {}

    };
</script>




// WEBPACK FOOTER //
// NewsItem3.vue?5d07aeb0